import { ADD_FACILITY_USER_SUCCESS, ADD_FACILITY_USER_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case ADD_FACILITY_USER_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case ADD_FACILITY_USER_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
